export const classes = [
  {
    name: "Gladiator",
    description: "Bring on any challenge, you'll have it, and you'll conquer it like your life depends on it.",
    primaryRole: "Assaulter",
    secondaryRole: "Vanguard",
  },
  {
    name: "Spellfencer",
    description: "It seems you have a kind of magic touch that gets you through a variety of challenges.",
    primaryRole: "Assaulter",
    secondaryRole: "Ruiner",
  },
  {
    name: "Monk",
    description: "Although you mostly train your body to beat people up, taking care of those in need is also part of your doctrine.",
    primaryRole: "Assaulter",
    secondaryRole: "Healer",
  },
  {
    name: "Assassin",
    description: "You'll do whatever it takes to achieve your goal. Those opposing you better watch their backs if they know what's good for them.",
    primaryRole: "Assaulter",
    secondaryRole: "Disruptor",
  },
  {
    name: "Hero",
    description: "With the power of friendship, you're sure you and your friends can overcome any hardship in your way.",
    primaryRole: "Assaulter",
    secondaryRole: "Supporter",
  },
  {
    name: "Knight",
    description: "Anyone who threatens messing with the people you treasure will be punished by your hand.",
    primaryRole: "Vanguard",
    secondaryRole: "Assaulter",
  },
  {
    name: "Guardian",
    description: "People should just give up trying to mess with your friends, since they'd have to get past you.",
    primaryRole: "Vanguard",
    secondaryRole: "Ruiner",
  },
  {
    name: "Paladin",
    description: "Keeping your loved ones safe and sound is your most sacred duty, no matter the situation.",
    primaryRole: "Vanguard",
    secondaryRole: "Healer",
  },
  {
    name: "Trampler",
    description: "You don't guide others around obstacles, you just run over everything standing in the way.",
    primaryRole: "Vanguard",
    secondaryRole: "Disruptor",
  },
  {
    name: "Warden",
    description: "You always have to make sure everyone behaves well and don't get into trouble. And don't forget to bring a coat and an umbrella.",
    primaryRole: "Vanguard",
    secondaryRole: "Supporter",
  },
  {
    name: "Aetherblade",
    description: "Don't have the means to accomplish something? No problem, you'll create the means yourself.",
    primaryRole: "Ruiner",
    secondaryRole: "Assaulter",
  },
  {
    name: "Wallmaster",
    description: "You feel responsible for creating a walled-up safe space for everyone, while at the same time making sure it's not a confort zone.",
    primaryRole: "Ruiner",
    secondaryRole: "Vanguard",
  },
  {
    name: "Wizard",
    description: "People can count on you to come up with weird creative solutions for a variety of problems, even if they have no clue about how you came up with them.",
    primaryRole: "Ruiner",
    secondaryRole: "Healer",
  },
  {
    name: "Arcanist",
    description: "Always meticulously thinking about how you're going to make your enemies suffer mercilessly.",
    primaryRole: "Ruiner",
    secondaryRole: "Disruptor",
  },
  {
    name: "Magician",
    description: "Always coming up with different ways to entertain your guests, although people never get tired of seeing you perform that same old card trick.",
    primaryRole: "Ruiner",
    secondaryRole: "Supporter",
  },
  {
    name: "Cleric",
    description: "Helping those in need is your duty. Also beating up anyone who tries to interfere in said duty.",
    primaryRole: "Healer",
    secondaryRole: "Assaulter",
  },
  {
    name: "Templar",
    description: "Your friends are really lucky to have you caring for them with such devotion. Just make sure to let them breathe every now and then.",
    primaryRole: "Healer",
    secondaryRole: "Vanguard",
  },
  {
    name: "Druid",
    description: "People should form lines to ask for your advice. You're always ready to share your wisdom, along with some tea and incense.",
    primaryRole: "Healer",
    secondaryRole: "Ruiner",
  },
  {
    name: "Fanatic",
    description: "You care for your loved ones so much, that's so sweet. Just please don't get too obssessed, as things might get a bit out of hand.",
    primaryRole: "Healer",
    secondaryRole: "Disruptor",
  },
  {
    name: "Priest",
    description: "Your heart seems so pure it's almost unbelievable. Don't be afraid to indulge in worldly pleasures every once in a while.",
    primaryRole: "Healer",
    secondaryRole: "Supporter",
  },
  {
    name: "Thief",
    description: "Well, it's their fault they got robbed, walking around like the world is a fair place.",
    primaryRole: "Disruptor",
    secondaryRole: "Assaulter",
  },
  {
    name: "Grappler",
    description: "You're the kind of person that gives someone a full nelson while the others beat up the bastard.",
    primaryRole: "Disruptor",
    secondaryRole: "Vanguard",
  },
  {
    name: "Bomber",
    description: "Just light the fuse, sit back, grab some popcorn and watch everything burn. There's no better entertainment.",
    primaryRole: "Disruptor",
    secondaryRole: "Ruiner",
  },
  {
    name: "Vampire",
    description: "The others have too much and you have too little. It's only fair to take from them, after all, you're all just trying to survive.",
    primaryRole: "Disruptor",
    secondaryRole: "Healer",
  },
  {
    name: "Mentalist",
    description: "You have a way with words, I'm sure you can just talk it out. Not sure if you're more of a diplomat or a con artist though.",
    primaryRole: "Disruptor",
    secondaryRole: "Supporter",
  },
  {
    name: "Explorer",
    description: "Always armed and ready, no one would be foolish enough to go on a new adventure without you as their guide.",
    primaryRole: "Supporter",
    secondaryRole: "Assaulter",
  },
  {
    name: "Provider",
    description: "You seem like the kind of person that really likes giving gifts to your friends.",
    primaryRole: "Supporter",
    secondaryRole: "Vanguard",
  },
  {
    name: "Scholar",
    description: "People often don't know what's more curious: the random knowledge you share or how you got to know it.",
    primaryRole: "Supporter",
    secondaryRole: "Ruiner",
  },
  {
    name: "Chemist",
    description: "You seem like the kind of person that just carries all sorts of medicine around, just in case anyone needs them.",
    primaryRole: "Supporter",
    secondaryRole: "Healer",
  },
  {
    name: "Performer",
    description: "A talented artist like you is always either entertaining everyone, or just pissing everyone off, no in-betweens.",
    primaryRole: "Supporter",
    secondaryRole: "Disruptor",
  },
];
